import React from 'react'
import { Controller } from 'react-hook-form'
import { useStyles } from './style'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

export default React.memo(({
  control,
  name,
  label,
  onChange = () => { },
  defaultValue = null,
  rules,
  valid,
  error,
  showErrors,
  minDate = new Date(),
  disabled,
  useLocaleDateStringLabel
}) => {
  const classes = useStyles()

  const handleChange = React.useCallback((date, field) => {
    if (!date || isNaN(date.valueOf())) return
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    const newDate = date.toISOString()
    onChange(newDate)
    field.onChange(newDate)
  }, [onChange])

  const handleLabel = React.useCallback(date => date?.toLocaleDateString() ?? '', [])

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} dateFormats={[]}>
          <DatePicker
            id='last-updated-picker'
            autoOk
            disabled={disabled}
            disablePast
            disableToolbar
            minDate={minDate}
            variant='inline'
            error={!valid}
            orientation='landscape'
            inputVariant='outlined'
            format='dd/MM/yyyy'
            margin='none'
            label={label || 'Date'}
            labelFunc={(useLocaleDateStringLabel && handleLabel) || undefined}
            value={field.value ? new Date(field.value) : null}
            onChange={date => handleChange(date, field)}
            classes={{ root: classes.dateFilterPicker }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
              classes: { root: classes.keyboardAdornment }
            }}
            InputProps={{
              classes: { adornedEnd: classes.dateFilterAdornedEnd }
            }}
            InputLabelProps={{
              classes: { root: classes.dateFilterLabel }
            }}
            helperText={(showErrors && !valid && error) || ''}
          />
        </LocalizationProvider>
      )}
    />
  )
})
